import { AceBadge } from '@/shared/components/ui/aceBadge';
import { cn } from '@/shared/utils/cn';

export interface DisplayNameProps {
  name: string;
  className?: string;
  badgeClassName?: string;
  isPremium?: boolean;
  /** Position of the ace badge relative to the name. Default: 'before' */
  badgePosition?: 'before' | 'after';
}

export function DisplayName(props: DisplayNameProps) {
  const {
    name,
    isPremium,
    className,
    badgeClassName,
    badgePosition = 'before',
  } = props;

  const badge = isPremium && (
    <AceBadge className={cn('shrink-0', badgeClassName)} />
  );

  return (
    <span className={cn('inline-flex items-center gap-1 truncate', className)}>
      {badgePosition === 'before' && badge}
      <span className="truncate">{name}</span>
      {badgePosition === 'after' && badge}
    </span>
  );
}
